<template>
  <div class="add-panel-network">
    <div class="add-panel-network__manufacturer">
      <label
        ><span class="add-panel-network__required">*</span> Производитель
        панели</label
      >
      <Select
        placeholder="Beward"
        clearable
        v-model="panelNetworkData.manufacturer"
        :options="manufacturers"
      />
    </div>

    <Input
      label="IP-адрес"
      placeholder="93.184.216.34:9780"
      tooltip="Внешний IP-адрес в формате IP-адрес:порт"
      required
      clearable
      v-model="panelNetworkData.ipAddress"
      :error="ipError"
    />
    <Input
      label="Логин"
      placeholder="admin"
      required
      clearable
      v-model="panelNetworkData.login"
    />
    <Input
      label="Пароль"
      placeholder="••••••••"
      :required="!isEditMode"
      clearable
      v-model="panelNetworkData.password"
      :type="showPassword ? 'text' : 'password'"
      :append-icon="showPassword ? 'eye' : 'eye-off'"
      @click:append="togglePasswordVisibility"
    />

    <Checkbox
      v-model="panelNetworkData.applyToAll"
      label="Применить логин и пароль ко всем панелям"
    />

    <span class="add-panel-network__title">Ссылка на видеопоток</span>
    <Input
      label="RTSP-поток"
      placeholder="rtsp://логин:пароль@ip-адрес:порт/путь"
      clearable
      v-model="panelNetworkData.rtspUrl"
    />

    <Alert type="info">
      Рекомендуем указывать RTSP поток с медиасервера. При указании потока
      напрямую из вызывной панели могут возникать сбои в работе устройства.
    </Alert>
  </div>
</template>

<script>
import Input from '../../Form/Input.vue'
import Select from '../../Form/Select.vue'
import Checkbox from '../../Form/Checkbox.vue'
import Alert from '../../Alert.vue'
import { getSharedCredentials } from '../../../utils/panelCredentials.js'
import { getIpAddressError } from '../../../validation/PanelValidation.js'

export default {
  name: 'AddPanelNetwork',
  components: {
    Input,
    Select,
    Checkbox,
    Alert,
  },
  data() {
    return {
      panelNetworkData: {
        manufacturer: '',
        ipAddress: '',
        login: '',
        password: '',
        applyToAll: false,
        rtspUrl: '',
      },
      showPassword: false,
    }
  },
  watch: {
    panelNetworkData: {
      handler(newVal) {
        if (newVal.applyToAll && (newVal.login || newVal.password)) {
          const credentials = {
            login: newVal.login,
            password: newVal.password,
          }
          localStorage.setItem(
            'sharedPanelCredentials',
            JSON.stringify(credentials)
          )
        } else {
          localStorage.removeItem('sharedPanelCredentials')
        }

        this.$store.dispatch('setPanelData', {
          key: 'network',
          value: newVal,
        })
      },
      deep: true,
    },
  },
  computed: {
    manufacturers() {
      return this.$store.getters.manufacturersOptions
    },
    existingPanels() {
      return this.$store.getters.panels || []
    },
    ipError() {
      return getIpAddressError(this.panelNetworkData.ipAddress)
    },
    isEditMode() {
      return this.$store.getters.isEditMode
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
  },
  mounted() {
    const storedData = this.$store.getters.panelData?.network

    const savedCredentials = getSharedCredentials() || {}
    const { login, password } = savedCredentials
    const applyToAll = login || password ? true : storedData.applyToAll

    this.panelNetworkData = {
      ...this.panelNetworkData,
      ...storedData,
      login: login || storedData?.login || '',
      password: password || storedData?.password || '',
      applyToAll,
    }
  },
}
</script>

<style lang="scss" scoped>
.add-panel-network {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__title {
    font-weight: $font-weight-lg;
    font-size: $font-size-lg;
    line-height: $line-height-lg;
    letter-spacing: -0.03em;
  }

  &__manufacturer {
    display: flex;
    flex-direction: column;
    gap: 8px;

    label {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      color: $color-grey-3;
    }
  }

  &__required {
    color: $color-red;
  }

  :deep(.multiselect) {
    height: 48px !important;
    border-radius: $border-radius-xs !important;
  }

  :deep(.multiselect-wrapper) {
    height: 48px !important;
    border-radius: $border-radius-xs !important;
  }

  :deep(.multiselect-search) {
    width: calc(100% - 14px) !important;
    height: auto !important;
    top: auto !important;
    bottom: auto !important;
  }

  :deep(.multiselect-placeholder) {
    color: $input-placeholder-color !important;
  }
}
</style>
